export const faqItems = [
  {
    id: 1,
    question: '麻花影院提供哪些类型的电影资源？',
    answer: '麻花影院聚合了最新动作片、科幻片、喜剧电影、悬疑惊悚、爱情片、动画电影等十余个分类的高清大片资源，覆盖国内外热门影片，片库每日更新，满足不同观众的观影口味。',
  },
  {
    id: 2,
    question: '麻花影院的影片画质如何？',
    answer: '平台主推高清在线观看体验，大部分影片支持1080P及以上的画质选项。我们持续优化播放链路，确保流畅不卡顿，让观众享受沉浸式的大片观影体验。',
  },
  {
    id: 3,
    question: '是否需要注册才能观看？',
    answer: '麻花影院主打免费在线观看，无需注册登录即可直接浏览和观看平台上的所有影片资源。我们致力于降低观影门槛，让好内容触手可及。',
  },
  {
    id: 4,
    question: '影片更新频率是怎样的？',
    answer: '我们的内容团队每日跟进全球院线和网络上映动态，热门电影上线后第一时间同步资源。每周新增影片超过50部，确保您总能看到最新最热的电影大片。',
  },
  {
    id: 5,
    question: '麻花影院支持哪些设备观看？',
    answer: '麻花影院全面适配PC端、平板和手机浏览器，无论您在家用电脑还是出门用手机，都能获得一致的高清观影体验。建议使用Chrome或Safari浏览器获得最佳效果。',
  },
];

export const cardItems = [
  {
    id: 1,
    title: '动作大片专区',
    description: '集结年度最火爆的动作电影，枪战、追逐、格斗场面应有尽有，肾上腺素飙升的观影体验。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20action%20movie%20scene%20with%20explosive%20urban%20battle%20cinematic%20lighting%20warm%20orange%20and%20red%20tones%20dramatic%20composition%20high%20contrast%20film%20grain%20texture%20professional%20movie%20poster%20style&width=800&height=500&seq=mahua-card-01&orientation=landscape',
    tag: '热门分类',
  },
  {
    id: 2,
    title: '科幻巨制合集',
    description: '从太空史诗到未来世界，汇聚全球顶级科幻大片，震撼视效带你穿梭星际、探索未知宇宙。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20spacecraft%20and%20distant%20galaxy%20neon%20blue%20accents%20on%20dark%20background%20cinematic%20lighting%20epic%20scale%20professional%20movie%20poster%20style%20atmospheric&width=800&height=500&seq=mahua-card-02&orientation=landscape',
    tag: '热门分类',
  },
  {
    id: 3,
    title: '喜剧电影精选',
    description: '汇聚国内外高分喜剧片，从黑色幽默到轻松爆笑，承包你一周的笑点，解压放松首选。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20bright%20comedy%20movie%20scene%20with%20friends%20laughing%20together%20in%20a%20cozy%20living%20room%20soft%20golden%20lighting%20happy%20atmosphere%20cinematic%20style%20professional%20movie%20poster%20composition&width=800&height=500&seq=mahua-card-03&orientation=landscape',
    tag: '热门分类',
  },
  {
    id: 4,
    title: '悬疑惊悚剧场',
    description: '烧脑剧情、反转结局，精选全球高分悬疑惊悚片，每一部都让你屏息凝神猜到最后一秒。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20thriller%20movie%20scene%20with%20shadowy%20figure%20in%20dim%20alley%20rain%20soaked%20street%20moody%20atmospheric%20lighting%20dark%20tones%20cinematic%20composition%20professional%20film%20poster%20style&width=800&height=500&seq=mahua-card-04&orientation=landscape',
    tag: '热门分类',
  },
  {
    id: 5,
    title: '动画电影天地',
    description: '迪士尼、皮克斯、吉卜力及国产精品动画一网打尽，全年龄段适合，亲子观影首选专区。',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20animated%20movie%20scene%20with%20fantasy%20forest%20and%20magical%20creatures%20vibrant%20warm%20colors%20soft%20dreamy%20lighting%20whimsical%20atmosphere%20cinematic%20style%20professional%20animation%20poster%20composition&width=800&height=500&seq=mahua-card-05&orientation=landscape',
    tag: '热门分类',
  },
];

export const indexItems = [
  {
    id: 1,
    title: '本周必看·编辑力荐',
    count: 12,
    icon: 'ri-fire-line',
    description: '编辑团队每周精选不容错过的口碑佳作',
  },
  {
    id: 2,
    title: '新片速递·刚出炉',
    count: 28,
    icon: 'ri-rocket-line',
    description: '最新上线的高清热门电影一站看完',
  },
  {
    id: 3,
    title: '动作猛片·肾上腺素',
    count: 156,
    icon: 'ri-flashlight-line',
    description: '枪战格斗追击，最燃动作大片合集',
  },
  {
    id: 4,
    title: '科幻世界·想象无边',
    count: 89,
    icon: 'ri-planet-line',
    description: '太空史诗与未来幻想，震撼视觉盛宴',
  },
  {
    id: 5,
    title: '喜剧专场·笑到停不下来',
    count: 134,
    icon: 'ri-emotion-laugh-line',
    description: '国内外高分喜剧电影，欢乐不断电',
  },
  {
    id: 6,
    title: '悬疑迷局·烧脑推荐',
    count: 67,
    icon: 'ri-search-eye-line',
    description: '反转不断的高分悬疑惊悚片精选',
  },
  {
    id: 7,
    title: '经典重温·百看不厌',
    count: 203,
    icon: 'ri-vidicon-line',
    description: '影史经典佳作，值得反复品味的电影',
  },
];

export const commentItems = [
  {
    id: 1,
    name: '影迷小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Chinese%20man%20with%20warm%20smile%20clean%20studio%20background%20soft%20lighting%20portrait%20photography&width=80&height=80&seq=mahua-avatar-01&orientation=squarish',
    text: '麻花影院的片库真的太全了！我想看的动作片和科幻片基本都有，而且画质很清晰。每天下班回家就靠它放松了，推荐给了好几个朋友！',
    rating: 5,
    date: '2026-07-28',
  },
  {
    id: 2,
    name: '周末观影人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Chinese%20woman%20with%20gentle%20expression%20clean%20studio%20background%20soft%20natural%20lighting%20portrait%20photography&width=80&height=80&seq=mahua-avatar-02&orientation=squarish',
    text: '作为资深影迷，这个平台的更新速度确实快。好多刚下映的大片这里很快就能看到高清版本了，绝对是追新片的神器！',
    rating: 5,
    date: '2026-07-25',
  },
  {
    id: 3,
    name: '宅家电影控',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Chinese%20man%20with%20casual%20style%20clean%20studio%20background%20warm%20lighting%20portrait%20photography&width=80&height=80&seq=mahua-avatar-03&orientation=squarish',
    text: '喜剧片分类做得特别好，周末窝在沙发上连看了三部，笑得肚子疼。分类清晰找片也方便，给产品点个赞！',
    rating: 4,
    date: '2026-07-22',
  },
  {
    id: 4,
    name: '深夜影咖',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Chinese%20woman%20with%20thoughtful%20expression%20clean%20studio%20background%20soft%20lighting%20portrait%20photography&width=80&height=80&seq=mahua-avatar-04&orientation=squarish',
    text: '悬疑片资源很丰富，好多冷门高分片在这里都能找到。画质和字幕质量都挺不错的，强烈推荐给喜欢烧脑片的影迷。',
    rating: 5,
    date: '2026-07-20',
  },
  {
    id: 5,
    name: '家庭观影团',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20middle-aged%20Chinese%20man%20with%20warm%20smile%20clean%20studio%20background%20soft%20lighting%20portrait%20photography&width=80&height=80&seq=mahua-avatar-05&orientation=squarish',
    text: '动画电影区很全，孩子喜欢的迪士尼和国产动画都有，周末亲子时光全靠它了。免费高清这一点太良心了！',
    rating: 5,
    date: '2026-07-18',
  },
];

export const updatesItems = [
  {
    id: 1,
    date: '2026-07-31',
    title: '《银河护卫队4》高清版重磅上线',
    description: '漫威年度科幻巨制高清资源已就位，全平台同步更新',
    tag: '新片上线',
  },
  {
    id: 2,
    date: '2026-07-30',
    title: '暑期档喜剧电影专区开放',
    description: '精选20部暑期爆笑喜剧电影，陪你清凉一夏',
    tag: '专题更新',
  },
  {
    id: 3,
    date: '2026-07-29',
    title: '平台片库突破5000部大关',
    description: '麻花影院高清电影资源总量正式突破5000部，持续增长中',
    tag: '里程碑',
  },
  {
    id: 4,
    date: '2026-07-28',
    title: '动作片专区新增15部经典港片',
    description: '成龙、李连杰、甄子丹经典动作电影高清修复版上线',
    tag: '片库更新',
  },
  {
    id: 5,
    date: '2026-07-26',
    title: '播放体验优化升级完成',
    description: '全面优化播放链路，加载速度提升40%，卡顿率大幅降低',
    tag: '系统公告',
  },
  {
    id: 6,
    date: '2026-07-24',
    title: '悬疑烧脑特辑·十部反转神片',
    description: '编辑精选十部结局反转的高分悬疑片，挑战你的推理能力',
    tag: '专题更新',
  },
  {
    id: 7,
    date: '2026-07-22',
    title: '科幻片专题「星际漫游」上线',
    description: '从《星际穿越》到《沙丘》，20部必看科幻大片一站式观影',
    tag: '专题更新',
  },
  {
    id: 8,
    date: '2026-07-20',
    title: '动画电影亲子专区全新改版',
    description: '新增按年龄段筛选功能，方便家长快速找到适合孩子的影片',
    tag: '功能更新',
  },
  {
    id: 9,
    date: '2026-07-18',
    title: '麻花影院夏季观影季启动',
    description: '整个夏天每天推荐一部精选大片，好片看不完',
    tag: '活动',
  },
];

export const rankingItems = [
  {
    rank: 1,
    title: '银河护卫队4',
    category: '科幻',
    hot: '9.8',
    trend: 'up',
  },
  {
    rank: 2,
    title: '极速追杀5',
    category: '动作',
    hot: '9.7',
    trend: 'up',
  },
  {
    rank: 3,
    title: '爆笑家族2',
    category: '喜剧',
    hot: '9.5',
    trend: 'up',
  },
  {
    rank: 4,
    title: '深渊之谜',
    category: '悬疑',
    hot: '9.4',
    trend: 'up',
  },
  {
    rank: 5,
    title: '星际迷航：新纪元',
    category: '科幻',
    hot: '9.3',
    trend: 'stable',
  },
  {
    rank: 6,
    title: '战狼3：使命',
    category: '动作',
    hot: '9.2',
    trend: 'up',
  },
  {
    rank: 7,
    title: '疯狂动物城3',
    category: '动画',
    hot: '9.1',
    trend: 'stable',
  },
];

export const topicItems = [
  { id: 1, name: '漫威宇宙', count: 47, icon: 'ri-movie-line' },
  { id: 2, name: 'DC超级英雄', count: 32, icon: 'ri-flashlight-line' },
  { id: 3, name: '国产科幻崛起', count: 28, icon: 'ri-rocket-line' },
  { id: 4, name: '港片经典', count: 89, icon: 'ri-building-line' },
  { id: 5, name: '韩国犯罪片', count: 41, icon: 'ri-knife-line' },
  { id: 6, name: '日本动画', count: 126, icon: 'ri-ghost-line' },
  { id: 7, name: '好莱坞大片', count: 203, icon: 'ri-star-line' },
  { id: 8, name: '高分纪录片', count: 55, icon: 'ri-camera-line' },
  { id: 9, name: '恐怖片精选', count: 38, icon: 'ri-moon-line' },
  { id: 10, name: '奥斯卡获奖', count: 64, icon: 'ri-award-line' },
];

export const mediaItems = [
  {
    id: 1,
    title: '银河护卫队4：终极冒险',
    description: '漫威宇宙最新力作，银河小分队迎来史上最强敌人',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20space%20adventure%20scene%20with%20colorful%20galaxy%20and%20heroic%20characters%20in%20action%20pose%20vibrant%20orange%20and%20blue%20lighting%20epic%20scale%20movie%20still%20quality&width=640&height=360&seq=mahua-media-01&orientation=landscape',
    duration: '2h 28min',
    tag: '热播中',
  },
  {
    id: 2,
    title: '极速追杀5：终章',
    description: '基努·里维斯回归，终极一战燃爆全场动作迷必看',
    image: 'https://readdy.ai/api/search-image?query=Intense%20action%20movie%20scene%20with%20man%20in%20dark%20suit%20holding%20weapon%20in%20rainy%20neon-lit%20city%20street%20dramatic%20red%20and%20blue%20lighting%20cinematic%20still%20quality&width=640&height=360&seq=mahua-media-02&orientation=landscape',
    duration: '2h 05min',
    tag: '热播中',
  },
  {
    id: 3,
    title: '爆笑家族2：暑假大作战',
    description: '全家总动员的爆笑喜剧续作，笑中带泪的温馨故事',
    image: 'https://readdy.ai/api/search-image?query=Warm%20family%20comedy%20scene%20with%20multigenerational%20family%20laughing%20in%20bright%20sunlit%20backyard%20golden%20hour%20lighting%20joyful%20atmosphere%20cinematic%20still%20quality&width=640&height=360&seq=mahua-media-03&orientation=landscape',
    duration: '1h 52min',
    tag: '推荐',
  },
  {
    id: 4,
    title: '深渊之谜：失踪者',
    description: '高分悬疑惊悚新片，层层反转不到最后猜不到结局',
    image: 'https://readdy.ai/api/search-image?query=Moody%20thriller%20scene%20with%20detective%20examining%20evidence%20in%20dimly%20lit%20room%20foggy%20atmosphere%20dark%20green%20and%20amber%20lighting%20cinematic%20still%20quality%20mysterious&width=640&height=360&seq=mahua-media-04&orientation=landscape',
    duration: '2h 12min',
    tag: '新上线',
  },
];

export const featureItems = [
  {
    id: 1,
    title: '海量高清片库',
    description: '5000+部高清电影资源，涵盖动作片、科幻片、喜剧等十余个分类，持续更新不断档。',
    icon: 'ri-film-line',
  },
  {
    id: 2,
    title: '免费在线观看',
    description: '无需注册登录，打开即可免费观看。高清画质流畅播放，零门槛享受大片体验。',
    icon: 'ri-play-circle-line',
  },
  {
    id: 3,
    title: '每日更新不断',
    description: '内容团队全天候跟进全球上映动态，热门影片第一时间上线，每周新增50+部。',
    icon: 'ri-refresh-line',
  },
  {
    id: 4,
    title: '全设备适配',
    description: 'PC、平板、手机全面适配，无论在哪都能享受流畅的高清观影体验。',
    icon: 'ri-device-line',
  },
];

export const carouselItems = [
  {
    id: 1,
    title: '暑期档·动作大片燃爆季',
    description: '年度最炸裂动作电影齐聚，从极速追杀到战狼归来，每一帧都是肾上腺素。立即进入动作专区，感受拳拳到肉的震撼体验。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20action%20movie%20collage%20with%20explosive%20urban%20scenes%20fast%20cars%20and%20heroic%20figures%20warm%20orange%20and%20red%20cinematic%20tones%20dramatic%20composition%20professional%20movie%20banner%20style&width=1200&height=600&seq=mahua-carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '科幻世界·星际漫游指南',
    description: '从银河护卫队到星际迷航，精选20部必看科幻巨制。震撼视效带你穿越星系探索未知，科幻迷的天堂就在这里。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20collage%20with%20spaceships%20nebula%20galaxies%20and%20astronauts%20deep%20blue%20and%20purple%20cosmic%20tones%20cinematic%20composition%20professional%20movie%20banner%20style&width=1200&height=600&seq=mahua-carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '喜剧合集·治愈不开心',
    description: '国内外高分喜剧电影大合集，从国产爆笑到好莱坞幽默，承包你一整季的笑点。生活需要笑声，从这里开始。',
    image: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20comedy%20movie%20collage%20with%20people%20laughing%20funny%20expressions%20warm%20yellow%20and%20pink%20tones%20joyful%20cinematic%20composition%20professional%20movie%20banner%20style&width=1200&height=600&seq=mahua-carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '悬疑烧脑·十大反转神作',
    description: '编辑精选十部结局出人意料的悬疑惊悚佳片，烧脑剧情层层递进。准备好挑战你的推理能力了吗？',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20thriller%20movie%20collage%20with%20shadows%20silhouettes%20and%20dramatic%20lighting%20moody%20green%20and%20amber%20tones%20suspenseful%20cinematic%20composition%20professional%20movie%20banner%20style&width=1200&height=600&seq=mahua-carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '动画天地·全家的欢乐时光',
    description: '迪士尼经典、皮克斯精品、吉卜力治愈、国产动画新秀，亲子观影一站式。和孩子一起走进奇幻动画世界。',
    image: 'https://readdy.ai/api/search-image?query=Magical%20animated%20movie%20collage%20with%20colorful%20fantasy%20worlds%20cute%20characters%20and%20dreamy%20landscapes%20soft%20pastel%20tones%20whimsical%20cinematic%20composition%20professional%20animation%20banner%20style&width=1200&height=600&seq=mahua-carousel-05&orientation=landscape',
  },
];